import { Navigate, useSearchParams } from 'react-router-dom'
import { usePermission, useRole } from '@/hooks/usePermission'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Mail, Database, Sparkles, Tags } from 'lucide-react'
import { EmailSettings } from './EmailSettings'
import { SinapiSettings } from './SinapiSettings'
import { AISettings } from './AISettings'
import { ExpenseCategorySettings } from './ExpenseCategorySettings'

export function SettingsPage() {
  const canEditTenant = usePermission('tenant:edit')
  const role = useRole()
  const canManageSinapi = role === 'ROOT' || role === 'MASTER'
  const [searchParams, setSearchParams] = useSearchParams()

  if (!canEditTenant) {
    return <Navigate to="/" replace />
  }

  const currentTab = searchParams.get('tab') || 'email'

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true })
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-neutral-900">Configuracoes</h1>
        <p className="mt-1 text-sm text-neutral-500">
          Gerencie as configuracoes do sistema
        </p>
      </div>

      <Tabs value={currentTab} onValueChange={handleTabChange}>
        <div className="overflow-x-auto">
          <TabsList className="w-max min-w-full sm:w-auto">
            <TabsTrigger value="email" className="gap-2">
              <Mail className="h-4 w-4" />
              Email / SMTP
            </TabsTrigger>
            {canManageSinapi && (
              <TabsTrigger value="sinapi" className="gap-2">
                <Database className="h-4 w-4" />
                Base SINAPI
              </TabsTrigger>
            )}
            {canManageSinapi && (
              <TabsTrigger value="ia" className="gap-2">
                <Sparkles className="h-4 w-4" />
                Integração com I.A.
              </TabsTrigger>
            )}
            <TabsTrigger value="expense-categories" className="gap-2">
              <Tags className="h-4 w-4" />
              Categorias de Despesa
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="email" className="mt-6">
          <EmailSettings />
        </TabsContent>

        {canManageSinapi && (
          <TabsContent value="sinapi" className="mt-6">
            <SinapiSettings />
          </TabsContent>
        )}

        {canManageSinapi && (
          <TabsContent value="ia" className="mt-6">
            <AISettings />
          </TabsContent>
        )}

        <TabsContent value="expense-categories" className="mt-6">
          <ExpenseCategorySettings />
        </TabsContent>
      </Tabs>
    </div>
  )
}
